import './css/app.css';
import 'vendor/lazysizes';
import { App } from '@grafikr/components';

import components from 'framework/components';
import state from 'framework/state';

const app = new App();

components(app);
state(app);

const searchParams = new URLSearchParams(window.location.search);
const token = searchParams.get('authtoken');
if (token && !theme.cart.attributes.uid) {
  const { default: firebaseSignInCheck } = await import(
    /* webpackChunkName: "modules-swiper" */ 'framework/firebase-signin'
    );
  firebaseSignInCheck();
}

app.mount();

document.addEventListener('shopify:section:load', app.mount);
document.addEventListener('app:remount', app.mount);
